module.exports = __webpack_public_path__ + "img/8.97f5b67a.svg";